import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { initTheme } from '@lineageatlas/design-system';
import './index.css';
import './styles/regenloop-full/index.css';

const isLandingRoute = window.location.pathname === '/';

if (isLandingRoute) {
  document.documentElement.setAttribute('data-theme', 'light');
} else {
  // Initialize dark/light theme before render for authenticated app surfaces.
  initTheme();
}

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
